import React, { Component } from 'react';
import './GroupDetail.css';

import { PencilIcon } from '../../../../../common/icons';
import { inject, observer } from 'mobx-react';
import UpdateGroupModal from './UpdateGroupModal';

@inject('translationsStore')
@observer
export default class GroupDetail extends Component {
  constructor(props) {
    super(props);

    this.UpdateGroupModalRef = React.createRef();

    this.state = {};
  }

  componentDidMount = () => {
    this.UpdateGroupModaInstance = this.UpdateGroupModalRef.current.wrappedInstance;
  };

  render() {
    const { group, visible, translationsStore } = this.props;
    return (
      <div className={`GroupDetail ${visible ? '' : 'hide'}`}>
        {!!visible && (
          <div className="groupDetailInner">
            <div>
              <div className="name">{group.name}</div>
              <div
                className="icon"
                onClick={() => {
                  this.UpdateGroupModaInstance.show();
                }}
              >
                <PencilIcon />
                <div className="label">{translationsStore.translate('udpate')}</div>
              </div>
            </div>
            <div className="description">{group.description}</div>
            <div className="description">{group.phoneNumber}</div>
          </div>
        )}
        <UpdateGroupModal ref={this.UpdateGroupModalRef} width={560} group={group} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/GroupDetail/GroupDetail.js